"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var visitorConnectionType_1 = require("../utils/visitorConnectionType");
var MobileIdentityService = /** @class */ (function () {
    function MobileIdentityService(_a) {
        var user = _a.user, sessionManager = _a.sessionManager, localStorage = _a.localStorage, logger = _a.logger, api = _a.api, browserEnvironment = _a.browserEnvironment;
        this.user = user;
        this.sessionManager = sessionManager;
        this.localStorage = localStorage;
        this.logger = logger;
        this.api = api;
        this.browserEnvironment = browserEnvironment;
    }
    MobileIdentityService.prototype.shouldIdentifyVisitor = function () {
        return this.isMobileIdentityEnabled() && (0, visitorConnectionType_1.getVisitorConnectionType)() !== 'non-mobile';
    };
    MobileIdentityService.prototype.storePhoneAndSendMiEvent = function (phone) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var isMiSent, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.isMobileIdentityEnabled())
                            return [2 /*return*/];
                        if (phone)
                            this.localStorage.set('mi', phone);
                        isMiSent = (_a = this.sessionManager.currentSession) === null || _a === void 0 ? void 0 : _a.miSent;
                        if (isMiSent)
                            return [2 /*return*/];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.sendMiEvent()];
                    case 2:
                        _b.sent();
                        this.sessionManager.markMi();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        this.logger.error("MobileIdentityService, sendMiEvent: Error - ".concat(e_1, " "));
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MobileIdentityService.prototype.sendMiEvent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var visitorIdentifier, cttToken, isMiInLocalStorage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        visitorIdentifier = this.localStorage.get('visitorIdentifier') || undefined;
                        cttToken = this.localStorage.get('cttToken') || null;
                        isMiInLocalStorage = this.localStorage.get('mi') !== null;
                        return [4 /*yield*/, this.api.postJson('/api/v2/track/mobileIdentification', {
                                cttToken: cttToken === null || cttToken === void 0 ? void 0 : cttToken.value,
                                visitorIdentifier: visitorIdentifier,
                                environment: this.browserEnvironment.snapshot,
                                userID: this.user.id,
                                networkConnection: (0, visitorConnectionType_1.getVisitorConnectionType)(),
                                identified: isMiInLocalStorage
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MobileIdentityService.prototype.isMobileIdentityEnabled = function () {
        return this.user.headerEnrichment;
    };
    return MobileIdentityService;
}());
exports.default = MobileIdentityService;
//# sourceMappingURL=data:application/json;base64,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